import { createFileRoute } from '@tanstack/react-router'
import { MailsPage } from '@/pages/mails/MailsPage'

export const Route = createFileRoute('/_private/mails/')({
    component: MailsPage,
})
